import { CLOVER_PATHS } from '@/components/VeraLoader';
import { cn } from '@/utils/cn';

interface VeraLogoProps {
  className?: string;
}

/** Trèfle Actual monochrome : prend la couleur du texte courant. */
export const VeraLogo = ({ className }: VeraLogoProps) => (
  <svg
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={cn('size-5', className)}
  >
    <g transform="translate(48 0) scale(-1 1)">
      {Object.values(CLOVER_PATHS).map((path) => (
        <path key={path} d={path} />
      ))}
    </g>
  </svg>
);
